import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import SignedinConfirmation from './signedin_confirmation';

/**
 * Unauthenticated route component is based off of a Mcginnis post at
 * https://tylermcginnis.com/react-router-protected-routes-authentication/
 *
 * Basically, the goal is to centralize 'protecting' a route to this component
 * so that route components can assume the user is not signed in. The only
 * place that UnauthenticatedRoute should be used is the top level App component, as
 * sub routes won't be updated correctly.
 */
class UnauthenticatedRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clean: true,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!nextProps.signedIn) {
      return ({ clean: false });
    }
    return prevState;
  }

  render() {
    const { clean } = this.state;
    const {
      exact,
      path,
      component,
      routeName,
      routeActionDescription,
      signedIn,
      computedMatch,
    } = this.props;
    const ProtectedComponent = component;
    return (
      <Route
        exact={exact}
        path={path}
        render={() => (
          (clean && signedIn)
            ? (
              <SignedinConfirmation
                routeName={routeName}
                routeActionDescription={routeActionDescription}
              />
            )
            : (
              <ProtectedComponent
                routeName={routeName}
                computedMatch={computedMatch}
              />
            )
        )}
      />
    );
  }
}

UnauthenticatedRoute.propTypes = {
  computedMatch: PropTypes.shape({
    params: PropTypes.shape({
      email: PropTypes.string,
      token: PropTypes.string,
    }),
  }).isRequired,
  exact: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
  routeName: PropTypes.string.isRequired,
  routeActionDescription: PropTypes.string.isRequired,
  signedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  signedIn: state.session.signedIn,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
}, dispatch);

// the withRouter here is necessary because the 'child routes' in app
// weren't reacting to location changes because they weren't recieving props
// from react router, see
// https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/redux.md
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(UnauthenticatedRoute));
